/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* istanbul ignore file */
/** @jsx jsx */
import { jsx } from 'theme-ui';
import React, { Fragment, ChangeEvent, useState, memo } from 'react';
import {
  Box,
  Text,
  Button,
  ButtonGroup,
  //   Checkbox,
  Flex,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Modal,
  ModalOverlay,
  ModalBody,
  ModalHeader,
  ModalFooter,
  ModalContent,
  IconButton,
  Input,
  //   Menu,
  //   MenuButton,
  //   MenuItem,
  //   MenuList,
  //   NumberInput,
  //   NumberInputField,
  //   Radio,
  //   RadioGroup,
  Select,
  Textarea,
  useDisclosure,
  useToast,
} from '@chakra-ui/core';
import { useTranslation } from 'react-i18next';
import DatePicker, { registerLocale } from 'react-datepicker';
import { enGB, fr } from 'date-fns/locale';
import _isNil from 'lodash/isNil';
import _isUndefined from 'lodash/isUndefined';
import _includes from 'lodash/includes';
import { useStoreActions, useStoreState } from '../../../../../models/hooks';
import { confirmationModalHeaderCSS } from './ConfirmationModal.styles';
import { DismissConfirmationModal } from './DismissConfirmationModal';
import { ReactComponent as _IconCalendar } from '../../../../../assets/img/icon-calendar-blue.svg';
import { useSeekerContainerContext } from '../../SeekerContainerContext';
import useHistory from '../../candidate/history/useHistory';
import useBusinessLocations from '../../../../administration/positionManagement/useBusinessLocations';
import { usePositionDocumentSnapshot } from './usePositionDocumentSnapshot';
import { reactDatePickerCSS } from '../../../../calendar/scheduleSidebar/ReactDatePicker.Style';
import { drawerCSS } from '../../../../calendar/CalendarView.Style';
import { DateAndTimePickerCoustomCSS } from '../../../../administration/positionManagement/createJobs/CreateJobPositionStyle';
import { BusinessSelectType } from '../../../../administration/positionManagement/PositionType';
import { clearErrorMessage, FormattedError, getErrorMessage } from '../../../../../utils/FormErrorUtils';
import { useCurrentUserProfile } from '../../../../../app/hooks/useCurrentUserProfile';
import { Requisition } from '../../../../../firebase/firestore/documents/requisition';
import colors from '../../../../../styles/colors';
import { getTranslatedNumber, getTranslatedStringValue } from '../../../../../utils/localizedNumber';
import useCandidate from '../../../../../app/components/useCandidate';

const IconCalendar = memo(_IconCalendar);
registerLocale('fr', enGB);

registerLocale('fr', fr);

export type HireRejectModalProps = {
  isOpen: boolean;
  disabled?: boolean;
  onClose: () => void;
  warningMessage?: boolean;
  messageModalOpen?: () => void;
  candidateIdFromProps: string;
  isFromDashboard?: boolean;
  selectedToDoItem?: {
    id: string;
    task: string;
    candidateName: string;
    candidateId: string;
    helpRequestedMessages?: {
      userType: string;
      message: string;
      timestamp: Date;
      name: string;
    }[];
    latestHelpRequestFor?: string;
    seekerHireDetailId?: string;
    hireDetailsRequestedAt?: string;
  };
  onSuccessCallback?: () => void;
};

export type HireInfo = {
  businessLocation: string;
  jobPosition: string;
  joinDate?: Date | null;
  notes: string | null;
};

export type NoteDetail = {
  salary: string | number;
  salaryUnit?: string;
  customSalaryUnit?: string;
};

const DefaultHireInfo: HireInfo = {
  joinDate: null,
  jobPosition: '',
  businessLocation: '',
  notes: '',
};

export const HireRejectCandidateModal = ({
  isOpen,
  onClose,
  candidateIdFromProps,
  isFromDashboard = false,
  selectedToDoItem,
  onSuccessCallback,
}: HireRejectModalProps): JSX.Element => {
  const { t, i18n } = useTranslation();
  const userId = useStoreState((states) => states.app.user?.id);
  const { isOpen: isDismissModalOpen, onOpen: onDismissModalOpen, onClose: onDismissModalClose } = useDisclosure();
  const { isOpen: isOpenConformationModal, onOpen: onOpenConformationModal, onClose: onCloseConformationModal } = useDisclosure();
  const { selectedCandidate, setSelectedCandidate } = useSeekerContainerContext();
  // const { setSelectedEngagedCandidate, setSelectedEngagedSeeker } = useMessagingViewContext();
  //   const { selectedSeeker } = useMessagingViewContext();
  const candidateFromDashboard = useCandidate(candidateIdFromProps);
  const candidate = candidateFromDashboard?.candidate;

  const { currentUserProfile } = useCurrentUserProfile();
  const { histories } = useHistory(candidate);
  const businessLocations = useBusinessLocations();

  const candidateFrom = selectedCandidate || candidate;

  const requisitionEnabled = useStoreState((state) => state.app.accounts?.configuration?.requisitionEnabled);
  //   const accountLocale = useStoreState((s) => s.app.user?.locale);

  const offeredSalary = histories?.getRecentOfferMadeStatus()?.[0]?.offeredSalary;
  const positionDocument = usePositionDocumentSnapshot(candidateFrom?.position);

  const isHireFormEnabled = useStoreState((s) => s.app.accounts?.configuration?.hireFormEnabled);
  const hireFormEnabledPositions = useStoreState((s) => s.app.accounts?.configuration?.hireFormEnabledPositions);

  const selectedBusinessLocation = businessLocations.find((businessLocation) =>
    candidateFrom?.newHireData?.businessId
      ? businessLocation.id === candidateFrom.newHireData.businessId
      : businessLocation.id === positionDocument?.business,
  );

  const earliestAvailabilityDate = candidateFrom?.earliestAvailabilityDate;

  const hireCandidate = useStoreActions((actions) => actions.messaging.hireCandidate);
  const dismissCandidate = useStoreActions((actions) => actions.messaging.dismissCandidate);
  const saveOfferRejectedNote = useStoreActions((actions) => actions.account.saveOfferRejectedNote);
  const { updateRecruiterActionStatus } = useStoreActions((actions) => actions.toDoList);

  const [fromHireReject, setFromHireReject] = useState<boolean>(true);
  const [radioValue, setRadioValue] = useState<string>('hired');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [formErrors, setFormErrors] = useState<FormattedError[]>([]);
  const [updatedPositionId, setUpdatedPositionId] = useState<string | undefined>(undefined);
  const [salary, setSalary] = useState<string>('');
  const [unit, setUnit] = useState<string>('hourly');
  const [customUnit, setCustomUnit] = useState<string | null>('');
  const [dismissedCandidateAfterRejection, setDismissedCandidateAfterRejection] = useState<boolean>(true);
  const [selectedRequisition, setSelectedRequisition] = useState<Requisition | undefined>(undefined);
  const [businessLocation, setBusinessLocation] = useState<BusinessSelectType | null>(null);
  // const [hireInfo, setHireInfo] = useState<HireInfo>(DefaultHireInfo);
  const [updatedBusinessId, setUpdatedBusinessId] = useState<string | undefined>(undefined);

  const [joinDate, setJoinDate] = useState<Date | null | undefined>(
    earliestAvailabilityDate ? new Date(earliestAvailabilityDate) : undefined,
  );

  const toast = useToast();

  let noteDetail: NoteDetail | undefined;

  const shouldAllowHireForm = () => {
    if (isHireFormEnabled) {
      if (updatedPositionId) {
        return _includes(hireFormEnabledPositions, updatedPositionId);
      }
      if (candidateFrom?.newHireData) {
        return _includes(hireFormEnabledPositions, candidateFrom?.newHireData?.positionId);
      }
      return _includes(hireFormEnabledPositions, candidateFrom?.position);
    }
    return false;
  };

  // const [noteContent, setNoteContent] = useState<string | null>(
  //   shouldAllowHireForm() ? null : `${t('messaging:actions.hire.hireDetailsDesc1')}`,
  // );

  const [noteContent, setNoteContent] = useState<string | null>('');

  React.useEffect(() => {
    setSalary(Number(offeredSalary?.salary).toFixed(2).toString() || '');
  }, [offeredSalary]);

  React.useEffect(
    () => () => {
      setIsLoading(false);
      setNoteContent('');
      //   setSalary('0');
      setUnit('hourly');
      setCustomUnit('');
      setJoinDate(earliestAvailabilityDate ? new Date(earliestAvailabilityDate) : null);
    },
    [earliestAvailabilityDate],
  );

  React.useEffect(() => {
    let givenSalary = noteDetail?.salary;
    if (_isUndefined(givenSalary)) {
      givenSalary = '';
    }

    setSalary(getTranslatedNumber(Number(givenSalary).toFixed(2).toString(), i18n.language) as any);
    setUnit(noteDetail?.salaryUnit ?? 'hourly');
    setCustomUnit(noteDetail?.customSalaryUnit ?? '');
  }, [noteDetail, i18n.language]);

  React.useEffect(() => {
    if (!_isUndefined(earliestAvailabilityDate)) {
      setJoinDate(earliestAvailabilityDate ? new Date(earliestAvailabilityDate) : null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [candidateFrom?.earliestAvailabilityDate]);

  React.useEffect(() => {
    if (_isNil(businessLocation) && !_isNil(selectedBusinessLocation) && !_isNil(selectedBusinessLocation.id)) {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      setBusinessLocation(selectedBusinessLocation);
    }
  }, [businessLocation, selectedBusinessLocation]);

  // const handleRadioValueChange = (e: ChangeEvent<HTMLInputElement>) => {
  //   if (e.target.value === 'rejected') {
  //     setNoteContent('');
  //   } else if (e.target.value === 'hired') {
  //     // istanbul ignore next
  //     setNoteContent(shouldAllowHireForm() ? '' : `${t('messaging:actions.hire.hireDetailsDesc1')}`);
  //   }
  //   setRadioValue(e.target.value);
  // };

  const handleJoinDateChange = (date: Date) => {
    setJoinDate(date);
  };

  const updateNoteContent = (e: ChangeEvent<HTMLTextAreaElement>) => {
    setNoteContent(e.target.value);
  };
  const handleCustomUnitChange = (e: ChangeEvent<HTMLInputElement>) => {
    setCustomUnit(e.target.value);
  };

  const CustomDatePickerInput = (props: React.HTMLProps<HTMLInputElement>, ref: React.Ref<HTMLInputElement>) => (
    <ButtonGroup className="customDatepicker" size="md" isAttached variant="outline" onClick={props.onClick} ref={ref}>
      <Button mr="-px" style={{ width: '100%' }}>
        {props.value}
      </Button>
      <IconButton style={{ padding: '0.2rem' }} aria-label="calendar" icon={<IconCalendar width={20} height={20} />} />
    </ButtonGroup>
  );

  //   const handleJobLocationChange = (businessLocationItem: BusinessSelectType | null) => {
  //     if (!_isNil(businessLocationItem)) {
  //       setHireInfo((prevData) => ({
  //         ...prevData,

  //         businessLocation: businessLocationItem.value,
  //         jobPosition: '',
  //       }));
  //       setBusinessLocation(businessLocationItem);
  //       setActiveBusiness({
  //         name: businessLocationItem?.value,
  //         country: businessLocationItem?.country,
  //         address: businessLocationItem?.completeAddress,
  //         locationId: businessLocationItem?.locationId,
  //       });
  //       setSelectedRequisition(undefined);
  //       setPreviousRequisitionID(undefined);
  //       if (selectedCandidate?.newHireData) {
  //         setUpdatedBusinessId(businessLocationItem.id);
  //       } else {
  //         setUpdatedBusinessId(businessLocationItem.id === selectedBusinessLocation?.id ? undefined : businessLocationItem.id);
  //       }
  //       setUpdatedPositionId(undefined);
  //       setJoinDate(earliestAvailabilityDate ? new Date(earliestAvailabilityDate) : undefined);
  //     }
  //     setFormErrors(clearErrorMessage(formErrors, 'businessName'));
  //   };

  //   const handleJobChange = (jobPositionItem: PositionSelectType | null) => {
  //     let givenSalary = noteDetail?.salary;
  //     if (_isUndefined(givenSalary)) {
  //       givenSalary = '';
  //     }

  //     if (!_isNil(jobPositionItem)) {
  //       setHireInfo((prevData) => ({
  //         ...prevData,

  //         jobPosition: jobPositionItem.value,
  //       }));
  //       if (selectedCandidate?.newHireData) {
  //         setUpdatedPositionId(jobPositionItem.id);
  //       } else {
  //         setUpdatedPositionId(jobPositionItem.id === selectedCandidate?.position ? undefined : jobPositionItem.id);
  //       }
  //       if (jobPositionItem.id !== selectedCandidate?.position) {
  //         setSalary(
  //           !_isNil(jobPositionItem?.proposedSalary)
  //             ? handleNullValue('salary', jobPositionItem?.proposedSalary?.minValue)
  //             : '0.00',
  //         );
  //         setUnit(
  //           !_isNil(jobPositionItem?.proposedSalary) ? handleNullValue('unit', jobPositionItem?.proposedSalary?.unit) : 'hourly',
  //         );
  //         setCustomUnit(
  //           !_isNil(jobPositionItem?.proposedSalary)
  //             ? handleNullValue('customUnit', jobPositionItem?.proposedSalary?.customUnit)
  //             : '',
  //         );
  //       } else {
  //         setSalary(getTranslatedNumber(Number(givenSalary).toFixed(2).toString(), i18n.language) as any);
  //         setUnit(noteDetail?.salaryUnit ?? 'hourly');
  //         setCustomUnit(noteDetail?.customSalaryUnit ?? '');
  //       }
  //       setJoinDate(earliestAvailabilityDate ? new Date(earliestAvailabilityDate) : null);
  //     }

  //     setFormErrors(clearErrorMessage(formErrors, 'positionName'));
  //     setSelectedRequisition(undefined);
  //   };

  const handleUnitChange = (e: ChangeEvent<HTMLSelectElement>) => {
    setUnit(e.target.value);
    if (e.target.value !== 'custom') {
      setCustomUnit(null);
    }
    setFormErrors(clearErrorMessage(formErrors, 'note'));
  };

  const submitNote = async (dismissNote?: string, dismissNoteArea?: string) => {
    onCloseConformationModal();
    if (!candidateFrom || !currentUserProfile) return;

    try {
      setIsLoading(true);
      await saveOfferRejectedNote({
        positionId: candidateFrom.position,
        seekerId: candidateFrom.seeker,
        offerRejectedDetails: noteContent,
      });
      if (dismissedCandidateAfterRejection) {
        await dismissCandidate({
          positionId: candidateFrom.position,
          seekerId: candidateFrom.seeker,
          recruiterId: currentUserProfile.id,
          dismissalReason: dismissNote === 'Others' ? dismissNoteArea : dismissNote,
        });
      }
      onSuccessCallback?.();
      onClose();
    } finally {
      setIsLoading(false);
      setFromHireReject(false);
      toast({
        title: t('notes:noteSuccessMsg.title'),
        description: t('notes:noteSuccessMsg.description'),
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const onHandleSubmitButtonWithOutHireForm = async (note?: string, noteTextArea?: string) => {
    if (radioValue === 'hired') {
      if (updatedBusinessId || updatedPositionId) {
        onOpenConformationModal();
      }
    } else {
      await submitNote(note, noteTextArea);
    }
  };

  const onHandleSubmitButtonWithHireForm = async (note?: string, noteTextArea?: string) => {
    if (radioValue === 'hired') {
      //   if (updatedBusinessId || updatedPositionId) {
      //     onOpenConformationModal();
      //   } else {
      //     await onHandleRequestHireDetails();
      //   }
    } else if (radioValue === 'rejected') {
      await submitNote(note, noteTextArea);
    }
  };

  const onShouldAllowHireFormSaveClick = (note?: string, noteTextArea?: string) => {
    if (requisitionEnabled && radioValue !== 'rejected') {
      if (joinDate) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        onHandleSubmitButtonWithHireForm(note, noteTextArea);
      } else {
        const selectorId = `#elementID_earliest_start_date`;
        const section = document.querySelector(selectorId);
        section?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        setFormErrors([{ label: 'startingDate', message: t('messaging:actions.hire.confirmationModal.startDateRequired') }]);
      }
    } else {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      onHandleSubmitButtonWithHireForm(note, noteTextArea);
    }
  };

  const handleHireRequest = async () => {
    onCloseConformationModal();
    if (!candidateFrom) {
      return;
    }
    let updatedSalary: string;
    if (salary.includes(',')) {
      updatedSalary = salary.toString().replace(',', '.');
    } else {
      updatedSalary = salary.toString();
    }
    try {
      setIsLoading(true);
      await hireCandidate({
        positionId: candidateFrom.position,
        seekerId: candidateFrom.seeker,
        hireDetails: noteContent,
        salary: updatedSalary,
        salaryUnit: unit,
        dateOfJoining: joinDate === null ? /* istanbul ignore next */ undefined : joinDate,
        customSalaryUnit: customUnit,
        requisitionId: requisitionEnabled ? selectedRequisition?.requisitionId : '',
        updatedBusinessId: updatedBusinessId || candidateFrom?.newHireData?.businessId,
        updatedPositionId: updatedPositionId || candidateFrom?.newHireData?.positionId,
      });

      if (userId && isFromDashboard && selectedToDoItem) {
        await updateRecruiterActionStatus({
          userId,
          docId: selectedToDoItem.id,
          status: 'COMPLETED',
          category: selectedToDoItem.task,
          subCategory: null,
          candidateId: selectedToDoItem.candidateId,
        });
      }
      onSuccessCallback?.();
      onClose();
    } finally {
      setIsLoading(false);
      setFromHireReject(false);
      // changeCandidateOnTheLeftPanelHandler();
    }
  };

  const onDismissSuccess = async (note?: string, noteTextArea?: string) => {
    if (!shouldAllowHireForm()) {
      await onHandleSubmitButtonWithOutHireForm(note, noteTextArea);
    } else {
      onShouldAllowHireFormSaveClick(note, noteTextArea);
    }
  };

  return (
    <Box>
      <Modal
        id="HireRejectConfirmationModal"
        isOpen={isOpen}
        onClose={onClose}
        closeOnOverlayClick={false}
        size="4xl"
        scrollBehavior="inside"
      >
        <ModalOverlay>
          <ModalContent>
            <ModalHeader css={confirmationModalHeaderCSS} className="modal-header" style={{ color: 'black' }}>
              {t('messaging:actions.hire.rejectModal.header')}
            </ModalHeader>
            <ModalBody css={[drawerCSS, reactDatePickerCSS]}>
              {
                <Fragment>
                  {/* <Fragment>
                    <Text color="#455A63" mb="1rem">
                      {t('messaging:actions.hire.rejectModal.body')}
                    </Text>
                    <RadioGroup mb="2rem">
                      <Stack spacing={5} direction="row">
                        <Radio
                          isChecked
                          colorScheme="blue"
                          data-testid="Hired"
                          value="hired"
                          onChange={(e: ChangeEvent<HTMLInputElement>) => handleRadioValueChange(e)}
                        >
                          {t('messaging:actions.hire.rejectModal.hired')}
                        </Radio>
                        <Radio
                          colorScheme="blue"
                          data-testid="Rejected"
                          value="rejected"
                          onChange={(e: ChangeEvent<HTMLInputElement>) => handleRadioValueChange(e)}
                        >
                          {t('messaging:actions.hire.rejectModal.rejected')}
                        </Radio>
                      </Stack>
                    </RadioGroup>
                  </Fragment> */}
                  {radioValue === 'hired' && (
                    <Fragment>
                      <Flex alignItems="baseline">
                        <Box
                          mt="12px"
                          data-testid="DateOfJoining"
                          w="49%"
                          mr={3}
                          css={DateAndTimePickerCoustomCSS}
                          id="elementID_earliest_start_date"
                        >
                          <FormControl isRequired>
                            <FormLabel mb="8px" fontWeight="bold">
                              {t('messaging:actions.hire.dateOfJoining')}
                            </FormLabel>
                            <DatePicker
                              selected={joinDate}
                              customInput={React.createElement(React.forwardRef(CustomDatePickerInput))}
                              locale={i18n.language}
                              dateFormat="P"
                              shouldCloseOnSelect
                              minDate={
                                requisitionEnabled
                                  ? selectedRequisition?.effectiveDate && new Date(selectedRequisition?.effectiveDate)
                                  : null
                              }
                              onChange={
                                /* istanbul ignore next */ (date) => {
                                  handleJoinDateChange(date as Date);
                                  setFormErrors(clearErrorMessage(formErrors, 'startingDate'));
                                }
                              }
                            />
                            <FormErrorMessage>{getErrorMessage(formErrors, 'startingDate')}</FormErrorMessage>
                          </FormControl>
                        </Box>
                      </Flex>

                      <Fragment>
                        <Box display="flex" mb="1rem" data-testid="HiredDiv" mt="26px">
                          <Text mb="8px" fontWeight="bold" style={{ width: unit === 'custom' ? '33%' : '23%' }}>
                            {` ${t('messaging:actions.hire.confirmationModal.salary')} ($) : `}
                          </Text>
                          <Box
                            display="flex"
                            justifyContent="space-between"
                            style={{ marginTop: '-6px', marginLeft: '12px', width: unit === 'custom' ? '103%' : '74%' }}
                          >
                            <Select
                              onChange={(e: ChangeEvent<HTMLSelectElement>) => handleUnitChange(e)}
                              data-testid="UnitValue"
                              size="sm"
                              style={{ height: '40px', background: `${colors.gray['150']}`, border: 'none' }}
                              value={unit}
                            >
                              <option value="hourly">{t('messaging:actions.hire.confirmationModal.hourly')}</option>
                              <option value="annual">{t('messaging:actions.hire.confirmationModal.annually')}</option>
                              <option value="custom">{t('messaging:actions.hire.confirmationModal.custom')}</option>
                            </Select>
                            {unit === 'custom' && (
                              <Input
                                style={{
                                  marginLeft: '15px',
                                  height: '40px',
                                  background: `${colors.gray['150']}`,
                                  border: 'none',
                                }}
                                value={customUnit ?? ''}
                                data-testid="CustomUnitValue"
                                onChange={(e: ChangeEvent<HTMLInputElement>) => handleCustomUnitChange(e)}
                                placeholder={t('messaging:actions.hire.confirmationModal.customUnit')}
                                size="sm"
                              />
                            )}
                            <Input
                              style={{
                                marginLeft: '15px',
                                height: '40px',
                                width: '90%',
                                background: `${colors.gray['150']}`,
                                border: 'none',
                              }}
                              value={getTranslatedStringValue(salary, i18n.language)}
                              data-testid="SalaryValue"
                              // onChange={(e: ChangeEvent<HTMLInputElement>) => handleSalaryChange(e)}
                              placeholder={t('messaging:actions.hire.confirmationModal.salaryValue')}
                              size="sm"
                            />
                          </Box>
                        </Box>

                        <Box mb="1rem" mt="12px">
                          <Text color="#455A63" mb="0.5rem" fontWeight="bold">
                            {t('messaging:actions.hire.modalMessage')}
                          </Text>
                          <Textarea
                            style={{ height: '65px', width: '100%', background: `${colors.gray['150']}`, border: 'none' }}
                            value={noteContent || ''}
                            data-testid="HireNoteContent"
                            resize="none"
                            onChange={(e: ChangeEvent<HTMLTextAreaElement>) => updateNoteContent(e)}
                            focusBorderColor="gray"
                            placeholder={t('messaging:actions.hire.rejectModal.seenToCandidatePlaceholder')}
                          />
                        </Box>
                      </Fragment>
                    </Fragment>
                  )}
                </Fragment>
              }
            </ModalBody>
            <ModalFooter justifyContent={candidateFrom?.newHireData ? 'space-between' : 'flex-end'}>
              {candidateFrom?.newHireData && (
                <Text fontStyle="italic" color={colors.orange} w="70%">
                  {t('requisition:locationAndPositionChanged')}
                </Text>
              )}
              <Flex>
                <Button data-testid="CancelButton" colorScheme="red" mr={3} onClick={() => onClose()} disabled={isLoading}>
                  {t('messaging:actions.hire.confirmationModal.cancelButton')}
                </Button>

                <Button isLoading={isLoading} colorScheme="blue" onClick={() => handleHireRequest()}>
                  {t('messaging:actions.hire.confirmationModal.confirmBtn')}
                </Button>
              </Flex>
            </ModalFooter>
          </ModalContent>
        </ModalOverlay>
      </Modal>

      {isDismissModalOpen && (
        <DismissConfirmationModal
          isOpen={isDismissModalOpen}
          disabled={false}
          onClose={onDismissModalClose}
          isMessagingView
          onDismissSuccess={onDismissSuccess}
          isFromHireReject={fromHireReject}
        />
      )}
    </Box>
  );
};
